import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    userPortalData: [],
    targetedAdsData: [],
    editDataAd: [],
    customizePortal: [],
    wirelessData: [],
    enableCpData: [],
}
const mutations = {
    SET_USER_PORTAL_DATA(state, data) {
        state.userPortalData = data
    },
    SET_TARGETED_ADS_DATA(state, data) {
        state.targetedAdsData = data
    },
    AD_EDIT_DATA(state, data) {
        state.editDataAd = data
    },
    DELETE_AD(state, data) {
        var index = state.targetedAdsData.addatas.targetedAds.findIndex(element => element.Ad.id == data);
        if (index != -1) {
            state.targetedAdsData.addatas.targetedAds.splice(index, 1);
        }
    },
    ADD_NEW_AD_DATA(state, data) {
        var index = state.targetedAdsData.addatas.targetedAds.findIndex(element => element.Ad.id == data[0].Ad.id);
        if (index == -1) {
            state.targetedAdsData.addatas.targetedAds.push(data[0]);
        }
    },
    ADD_NEW_AD_DETAIL_DATA(state, data) {
        if (state.targetedAdsData.adDetails != null) {
            state.targetedAdsData.adDetails.push(data[0]);
        }
    },
    SET_CUSTOMIZE_USER_PORTAL(state, data) {
        state.customizePortal = data
    },
    SET_WIRELESS_DATA(state, wireData) {
        var tData = {};
        var parseData = wireData.message;
        if (Object.keys(state.wirelessData).length == 0) {
            tData[wireData.accountId + '-wirelessData'] = parseData;
            state.wirelessData = tData;
        } else {
            Vue.set(state.wirelessData, wireData.accountId + '-wirelessData', parseData);
        }
    },
    ADD_WIRE_FILES_LIST(state, data) {
        var fileD = data.fileD;
        var accountId = data.accountId;
        if (Object.keys(state.wirelessData).length != 0 && state.wirelessData != 'noData') {
            state.wirelessData[accountId + "-wirelessData"].files.push(fileD);
        } else {
            var dataSet = {}
            dataSet[accountId + "-wirelessData"].files = fileD;
            state.wirelessData = dataSet;
        }

    },
    SET_ENABLE_CP_DATA(state, enCpData) {
        var tData = {};
        var parseData = enCpData.message;
        if (Object.keys(state.enableCpData).length == 0) {
            tData[enCpData.accountId + '-enableCpData'] = parseData;
            state.enableCpData = tData;
        } else {
            Vue.set(state.enableCpData, enCpData.accountId + '-enableCpData', parseData);
        }
    },
}
const actions = {
    fetchUserPortalDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/captive_portal_settings/user_portal_list')
            .then(res => {
                Nprogress.done();
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  }
                  else{
                    commit("SET_USER_PORTAL_DATA", res.data)
                  }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    fetchTargetedAdsDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/captive_portal_settings/targeted_ads_list')
            .then(res => {
                Nprogress.done();
                if(res.data.status=='redirect')
                {
                    router.push("/dashboard");
                }
                else{
                commit("SET_TARGETED_ADS_DATA", res.data)
                }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    saveUserPortal({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/user_portal_submit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    applyToSubZone({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/add_all_userportal_to_subaccounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                   else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restrictToSubZone({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/save_sub_accounts_cannot_change_userportal', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getAdEditDatas({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal_settings/create_edit_ad/' + postData)
                .then(response => {
                    loader.hide()
                    commit("AD_EDIT_DATA", response.data);
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveAdEditDatas({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/add_edit_ad', postData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    commit('ADD_NEW_AD_DATA', response.data.lastAdId);
                    commit('ADD_NEW_AD_DETAIL_DATA', response.data.adNewDetails);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteAd({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/delete_ad.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('DELETE_AD', postData.id)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchCustomizeCaptivePortal({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/captive_portal_settings/captive_portal_setting_list')
            .then(res => {
                Nprogress.done()
                if(res.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else{
                        commit('SET_CUSTOMIZE_USER_PORTAL', res.data)
                    }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    editCustomizeData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal_settings/edit_cpdatas.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    savetosubzone({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/add_captive_portal_settings_to_all_accounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    resetDefault({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/action_todo.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveTextEditorDatas({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/cpdatas/edit_simul', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    uploadPictureCp({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post('/captive_portal_settings/captive_portal_setting_list', postData)
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                   else if (response.status != 200) {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response);

                })
                .catch(error => console.log(error));
        });
    },
    fetchWirelessInstruction({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/captive_portal_settings/wireless_instruction/true')
            .then(res => {
                Nprogress.done();
                commit("SET_WIRELESS_DATA", res.data)
            })
            .catch(error => console.log(error))
    },
    uploadWireSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/captive_portal_settings/import_file", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        fileD: response.data.fileD,
                        filesP: response.data.filesP,
                        accountId: postData.accountId,
                    }
                    commit('ADD_WIRE_FILES_LIST', dataList)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveWirelessInstructions({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal_settings/edit_wireless_instruction', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchEnableCpData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/captive_portal_settings/enable_captive_portal/true')
            .then(res => {
                Nprogress.done();
                commit("SET_ENABLE_CP_DATA", res.data)
            })
            .catch(error => console.log(error))
    },
    enableCaptiveSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal_settings/save_enable_captive_portal', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },

}
const getters = {
    userPortalDataGetters: state => {
        return state.userPortalData;
    },
    targetedAdsDataGetters: state => {
        return state.targetedAdsData;
    },
    targetedAdsEditGetters: state => {
        return state.editDataAd;
    },
    customizePortalGetters: state => {
        return state.customizePortal;
    },
    wirelessInstructionGetters: state => {
        return state.wirelessData;
    },
    enableCpGetters: state => {
        return state.enableCpData;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}

